import { render, staticRenderFns } from "./amount-dialog.vue?vue&type=template&id=7512fd26&scoped=true&"
import script from "./amount-dialog.vue?vue&type=script&lang=js&"
export * from "./amount-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7512fd26",
  null
  
)

export default component.exports